module.exports = __webpack_public_path__ + "./images/425d01b36d76739f3085e848e6f33a3d.webp";